var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3162 2.91008C20.9762 2.57008 20.4862 2.46008 20.0362 2.61008L3.68619 8.06008C3.13619 8.24008 2.79619 8.75008 2.83619 9.32008C2.87619 9.89008 3.27619 10.3601 3.83619 10.4701L11.9462 12.0901C12.0462 12.1101 12.1262 12.1901 12.1462 12.2901L13.7662 20.4001C13.8762 20.9601 14.3362 21.3701 14.9162 21.4001C14.9462 21.4001 14.9662 21.4001 14.9962 21.4001C15.5362 21.4001 16.0062 21.0701 16.1762 20.5501L21.6262 4.19008C21.7762 3.74008 21.6662 3.25008 21.3262 2.91008H21.3162ZM15.0362 19.1801L13.5962 12.0001C13.4562 11.3101 12.9162 10.7701 12.2262 10.6301L5.04619 9.19008L20.0362 4.19008L15.0362 19.1801Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.56151fbd5acb97fe9e9d4eb9b8c73c5f.svg";
export { ForwardRef as ReactComponent };